function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*#__NO_SIDE_EFFECTS__*/
var createUnitType = function createUnitType(unit) {
  return {
    test: function test(v) {
      return typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1;
    },
    parse: parseFloat,
    transform: function transform(v) {
      return "".concat(v).concat(unit);
    }
  };
};

var degrees = /*@__PURE__*/createUnitType("deg");
var percent = /*@__PURE__*/createUnitType("%");
var px = /*@__PURE__*/createUnitType("px");
var vh = /*@__PURE__*/createUnitType("vh");
var vw = /*@__PURE__*/createUnitType("vw");

var progressPercentage = /*@__PURE__*/function () {
  return _objectSpread(_objectSpread({}, percent), {}, {
    parse: function parse(v) {
      return percent.parse(v) / 100;
    },
    transform: function transform(v) {
      return percent.transform(v * 100);
    }
  });
}();

export { degrees, percent, progressPercentage, px, vh, vw };